"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$DeviceResponseDto = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
exports.$DeviceResponseDto = {
    properties: {
        _id: {
            type: 'string',
            description: `The record ID in the database`,
            isRequired: true,
        },
        device_id: {
            type: 'string',
            description: `The device Id in the backend`,
            isRequired: true,
        },
        device_manufacturer: {
            type: 'string',
            description: `Brand of the device`,
            isRequired: true,
        },
        device_model: {
            type: 'string',
            description: `Model of the device`,
            isRequired: true,
        },
        device_name: {
            type: 'string',
            description: `Name of the device`,
            isRequired: true,
        },
        device_platform: {
            type: 'string',
            description: `Platform of the device, android, ios or unknown`,
            isRequired: true,
        },
        device_system_version: {
            type: 'string',
            description: `Device System Version`,
            isRequired: true,
        },
        success: {
            type: 'boolean',
            description: `Is true if the notification was sent successfully`,
            isRequired: true,
        },
        error: {
            type: 'string',
            description: `Is error if the notification not was sent successfully`,
            isRequired: true,
        },
    },
};
